var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',[_c('h3',{staticClass:"prompt"},[_vm._v(_vm._s(_vm.willingToCallPrompt))]),_vm._v(" "),_c('radio-button',{attrs:{"button-data":_vm.buttonData,"name":"willing-to-call"},on:{"click":function($event){_vm.submit($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }